import { Pipe, PipeTransform } from '@angular/core';
import { iif, Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { Dictionary } from '@ngrx/entity';

import { isNullOrUndefined } from '@app/util/util';
import { AppFacade } from '@app/app.facade';
import { Place, PlaceSelectors } from '@app/entities/place';
import { BusTerminal } from '@app/entities/bus-company';
import { Airport } from '@app/modules/core/interfaces/airport';

@Pipe({
  name: 'placeName',
  standalone: false
})
export class PlaceNamePipe implements PipeTransform {

  constructor(private facade: AppFacade) { }

  transform(code: string, criteria: string = null, alternativesWithTerminals: boolean = false): Observable<string> {
    const key = getKeyValue(criteria);
    return zip(
      this.facade.placesEntities$,
      iif(
        () => !!alternativesWithTerminals,
        this.facade.terminalsEntities$,
        this.facade.airportsEntities$,
      )
    ).pipe(
      map(([places, alternative]) => {
        if (criteria === PlaceSelectors.AlternativeName) {
          return getNameByAlternative(alternative, code, PlaceSelectors.Name);
        } else if (places?.[code]) {
          return getNameByPlace(places, code, key, criteria);
        } else if (alternative?.[code]?.[key]) {
          return getNameByAlternative(alternative, code, key);
        } else {
          return getDefaultValue(code, criteria);
        }
      }));
  }
}

function getKeyValue(criteria: string): string {
  return isNullOrUndefined(criteria) ? PlaceSelectors.Name : criteria;
}

function getNameByPlace(places: Dictionary<Place>, code: string, key: string, criteria: string): string {
  if (criteria === PlaceSelectors.Statecode) {
    return places?.[code]?.[key] ? `(${places[code][key]})` : '';
  } else {
    return places?.[code]?.[key] ?? code;
  }
}

function getNameByAlternative(alternative: Dictionary<Airport> | Dictionary<BusTerminal>, code: string, key: string): string {
  return alternative?.[code]?.[key] ?? code;
}

function getDefaultValue(code: string, criteria: string): string {
  return criteria === PlaceSelectors.Statecode ? '' : code;
}
